import {
    StatusContainer,
    DataItem,
    PlansEntryReason,
    PlansListTelemetryStore,
} from '@servicetitan/financing-utils-shared';
import { Flex, Card, Text } from '@servicetitan/anvil2';
import {
    SetupDataStore,
    WorkflowStore,
    WorkflowButtonsStore,
} from '@servicetitan/financing-workflow-shared';
import { ApplicationDataStore } from '@servicetitan/financing-application-shared';
import UnderReviewIllustration from '../../common/illustrations/updating.svg';

const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    });
};

export const UnderReview = () => {
    const { setWorkflowStage } = WorkflowStore.useStore();
    const { setNextEntryReason } = PlansListTelemetryStore.useStore();
    const { setupData, setSetupData } = SetupDataStore.useStore();
    const { applicationData } = ApplicationDataStore.useStore();
    const { CloseWithoutConfirmingButton } = WorkflowButtonsStore.useStore();

    const handleDoneClick = () => {
        // Reset the workflow stage
        if (setupData?.isInSecondLook) {
            setSetupData({
                ...setupData,
                isInSecondLook: false,
            });
        }
        setNextEntryReason(PlansEntryReason.WorkflowReset);
        setWorkflowStage('reset');
    };

    return (
        <Flex
            direction="column"
            gap="4"
            style={{
                padding: '0 1.5rem 1.5rem 1.5rem',
                width: '100%',
            }}
        >
            <StatusContainer
                headline="Your application is under review"
                message="This page will be automatically updated when a decision is finalized."
                image={UnderReviewIllustration}
            >
                <Card flexDirection="column" gap="2" style={{ width: '100%' }}>
                    <Text variant="body" style={{ fontWeight: 'bold' }}>
                        Application Summary
                    </Text>
                    <DataItem
                        label="Applicant Name"
                        text={`${applicationData.applicant.primaryApplicant?.firstName} ${applicationData.applicant.primaryApplicant?.lastName}`}
                    />
                    <DataItem label="Date" text={formatDate(new Date())} />
                </Card>
                <CloseWithoutConfirmingButton
                    appearance="primary"
                    style={{
                        width: '100%',
                    }}
                    onClick={handleDoneClick}
                >
                    Done
                </CloseWithoutConfirmingButton>
            </StatusContainer>
        </Flex>
    );
};
